module.exports = __webpack_public_path__ + "static/media/IconTemplates_-40.817a01d3.svg";